document.addEventListener("DOMContentLoaded", () => {

    var container, video, playButton, pauseButton, muteButton

    const handlePause = () => {
        if (video.paused == false) {
            // Pause the video
            video.pause();
            playButton.classList.remove('hidden')
            pauseButton.classList.add('hidden')
        } else {
            console.log('pause error')
        }
    }

    const handlePlay = () => {
        if (video.paused == true) {
            // Play the video
            video.play();
            playButton.classList.add('hidden')
            pauseButton.classList.remove('hidden')
        } else {
            console.log('play error')
        }
    }

    const handleMute = () => {
        console.log('video:', video)
        console.log('muteButton:', muteButton)
        if (video.muted == false) {
            // Mute the video
            video.muted = true;
            muteButton.querySelector('.icon-mute').classList.remove('hidden')
            muteButton.querySelector('.icon-unmute').classList.add('hidden')
        } else {
            // Unmute the video
            video.muted = false;
            muteButton.querySelector('.icon-mute').classList.add('hidden')
            muteButton.querySelector('.icon-unmute').classList.remove('hidden')
        }
    }

    document.addEventListener('click', function(e) {
        
        if ( !e.target.closest('.pause') && !e.target.closest('.play') && !e.target.closest('.mute-wrap') ) return;
        //console.log('e.target: ', e.target)

        container = e.target.closest('.video-with-controls');
        video = container.querySelector('.hero-banner-video__video')
        playButton = container.querySelector('.play')
        pauseButton = container.querySelector('.pause')
        muteButton = container.querySelector('.mute-wrap')

        if (e.target.closest('button.pause')) handlePause();
        if (e.target.closest('button.play')) handlePlay();
        if (e.target.closest('.mute-wrap')) handleMute();

    });

});